
import React from 'react';
import Link from '../../elements/Link';
import { ExternalLinkIcon } from '../../svgs/DashboardSVGs';
import { SupportIcon } from '../../svgs/ExpressonSVGs';

type LoginMoreInfoProps = {
	data?: any // TODO: Change this
}

/**
 * Showing perks with the mina sidor
 *
 * @returns 
 */
const LoginMoreInfo: React.FC<LoginMoreInfoProps> = ({ data }) => {
	return (
		<div className="login-more-info">
			<h2 className="login-more-info__title">
				Mer information
			</h2>
			<div className="login-more-info__wrapper">
				<div className="questions">
					<details className="shadow-one">
						<summary>Vad är Mina Sidor?</summary>
						<p>
							Mina Sidor är din personliga portal där du kan hantera och övervaka ditt konto, tjänster och inställningar på ett säkert sätt.
							Här kan du enkelt få tillgång till viktig information, uppdatera dina uppgifter hantera dina kort, förbrukning och kostnader på ett smidigt sätt.
						</p>
					</details>
					<details className="shadow-one">
						<summary>Företag: Konto men inget inlogg?</summary>
						<p>Om du har ett konto hos oss men kan inte logga in så behöver du göra en behörighetstilldelning för ditt konto.</p>
						<p>Detta länkar ditt företagskonto till ett personnummer och du har efter det möjlighet att logga in.</p>
						<p><Link openNewTab={true} href={import.meta.env.VITE_VERIFIED_URL_COMPANY || "https://app.verified.eu/web/qstar-card-company/"}>Ansök om behörighetstilldelning</Link></p>
					</details>
					<details className="shadow-one">
						<summary>Logga in med BankID</summary>
						<p>
							Inloggning med BankID är en säker och smidig metod för att verifiera din identitet. Du använder helt enkelt ditt mobila BankID eller BankID på fil för att logga in. Detta garanterar att endast du har tillgång till din personliga information.
						</p>
						<p>
							Saknar du BankID kan du läsa mer om hur du skaffar det på <Link openNewTab={true} href="https://www.bankid.com/privat/skaffa-bankid">bankid.com</Link>.
						</p>
					</details>
					<details className="shadow-one">
						<summary>FAQ</summary>
						<p>
							På qstar.se hittar du svar på vanliga frågor om medlemskap, stationer, fakturor, kort och mycket mer. Kolla in vår <Link openNewTab={true} href="https://qstar.se/faq/">FAQ-sida</Link> för att hitta svar på dina frågor.
						</p>
					</details>
				</div>

				<div className="contact-us shadow-one">
					<span className="svg-icon-wrapper orange">
						<SupportIcon width={40} height={40} />
					</span>
					<h2 className="contact-us__title">Hittar du inte det du söker?</h2>
					<p className="no-margin">
						Vår kundservice är redo att hjälpa dig med alla dina frågor och funderingar. Tveka inte att höra av dig!
					</p>
					<Link openNewTab={true} className="dashboard-button" href={'https://qstar.se/kontakt/'}>
						Till kundservice
						<ExternalLinkIcon />
					</Link>
				</div>

			</div>
		</div>
	)
}

export default LoginMoreInfo